import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash-es';
import { useApi2fetch } from 'containers/Api2/index.js';
import { PASSWORDLENGTH } from './constants.js';

export const STRENGTH_EMPTY = { score: -1 };
const STRENGTH_SHORT = { score: -1, valid: false };

function useStrength(password, isAdmin, userData) {
  const api2fetch = useApi2fetch();
  const [strength, setStrength] = useState(STRENGTH_EMPTY);

  const fetchStrength = useCallback(debounce((body) => {
    try {
      api2fetch({ method: 'POST', url: 'useraccounts/password/strength', body, ignore: [422] }).then(setStrength);
    } catch (error) {
      setStrength({ score: 0, valid: false, error: error.message });
    }
  }, 500, { leading: true, trailing: true }), [api2fetch]);

  function getStrength() {
    if (!password) {
      setStrength(STRENGTH_EMPTY);
      return;
    }
    if (password.length < PASSWORDLENGTH) {
      setStrength(STRENGTH_SHORT);
      return;
    }
    fetchStrength({ password, isAdmin, ...userData });
  }

  useEffect(getStrength, [password, isAdmin, userData]);

  return strength;
}

export default useStrength;
